<template>
	<div class="sale-detail-purchase-wrap">
		<div style="display: flex;justify-content: space-between;">
			<h2 class="title">关联采购单</h2>
			<div 
				style="padding: 32px 16px 16px;font-size: 12px;text-decoration: underline;"
				@click="openAll"
				v-if="data.length > 0"
			>全部展开</div>
		</div>
		
		<van-collapse v-model="activeNames" v-if="data.length > 0">
		  <van-collapse-item v-for="(v, i) in data" :name="i + ''">
		    <template #title>
					<div class="coll-item-title-main">
						<div>{{ v.code }}</div>
						<div>{{ v.purchasetime_text }}</div>
					</div>
		      
					<div class="coll-item-title-part">
						<span style="color: #18bc9c;">{{ v.isep == 1 ? "EP货源" : "非EP货源"  }}</span>
						<span>SKU: {{ v.sku }}</span>
						<span>入库: {{ v.purchase_quantity }}</span>
						<span>已使用: {{ v.purchase_use_count }}</span>
					</div>
		    </template>
		    <!-- <p> 采购单号:PO-2308-0710-2715-6795</p> -->
		    <div class="detail-item"><div class="detail-label">合同编号：</div> JG202308031669</div>
		    <div class="detail-item"><div class="detail-label">供应商名称：</div> HS TECHNOLOGIES</div>
		    <div class="detail-item"><div class="detail-label">采购单位：</div> Polaris Mobility Solutions Co Ltd</div>
		    <div class="detail-item"><div class="detail-label">是否是否源：</div> <span style="color: #18bc9c;">{{ v.isep == 1 ? "EP货源" : "非EP货源"  }}</span></div>
		    <div class="detail-item"><div class="detail-label">SKU：</div> {{ v.sku }}</div>
				<div class="detail-item"><div class="detail-label">入&emsp;&emsp;库：</div> {{ v.purchase_quantity }}</div>
				<div class="detail-item"><div class="detail-label">已&nbsp;&nbsp;使&nbsp;&nbsp;用：</div> {{ v.purchase_use_count }}</div>
		    <div class="detail-item"><div class="detail-label">采购单价：</div> 【{{ v.purchase_currency }}】{{ v.purchase_amount }}</div>
		    <div class="detail-item"><div class="detail-label">合&emsp;&emsp;计：</div>  【{{ v.purchase_currency }}】{{ v.total_amount }}</div>
		    <div class="detail-item"><div class="detail-label">采购时间：</div>  {{ v.purchasetime_text }}</div>
		    <div class="detail-item"><div class="detail-label">入库时间：</div>  {{ v.storagetime_text }}</div>
				<div class="detail-item"><div class="detail-label">备&emsp;&emsp;注：</div> {{ v.remark }}</div>
		  </van-collapse-item>
		</van-collapse>
		<div
			v-else
			style="height: 50px;background-color: white;line-height: 50px;text-align: center;border-radius: 5px;"
		>暂无数据</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
			id: {
				type: [String, Number],
				default: () => {
					return 0;
				}
			}
		},
		data() {
		  return {
				activeNames: [],
				data: [],
		  };
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		  init() {
				this.getData();
			},
			getData() {
				this.$post(`${this.$api.stPurchaseSaleslog}${this.id}`, {}).then((res) => {
					if (res.code === 1) {
						this.data = res.data.rows;
					} else {
						this.$toast.fail((res.msg ? res.msg : '请求异常，请稍后重试'));
					}
				}).catch((e) => {
					this.$toast.fail(e);
				})
			},
			openAll() {
				for (let i in this.data) {
					if (!this.activeNames.includes(i)) {
						this.activeNames.push(i);
					}
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.sale-detail-purchase-wrap {
		margin: 24px;
		border-radius: 5px;
		.title {
				margin: 0;
				padding: 32px 16px 16px;
				color: rgba(69, 90, 100, 0.6);
				font-weight: normal;
				font-size: 14px;
				line-height: 16px;
		}
		
		.coll-item-title-main {
			display: flex;
			justify-content: space-between;
		}
		
		.coll-item-title-part {
			span {
				margin-right: 8px;
				font-size: 12px;
				color: #a5a0a0;
			};
		}
		.detail-label {
			width: 90px;
			text-align: right;
			display: inline-block;
		}
		
		.detail-item {
			margin-top: 8px;
		}
	}
</style>